import * as datefns from 'date-fns'
import { isSpecialUnitIssue } from '../issues/utils'
import { IssueEntity } from 'types/IssueEntity'
import { hasSourceOfType } from '../../components/utils/calculateIssueStatus'

const getMarketAdjustedDate = (date: Date | null) => {
    if (!date) return null

    const localDate = new Date(date.toLocaleDateString('sv-SE', { timeZone: 'Europe/Stockholm' }))

    const MARKET_CLOSE_TIME = '17:30:00' // market close time, in local time zone
    let adjustedDate

    if (datefns.format(localDate, 'HH:mm:ss') < MARKET_CLOSE_TIME) {
        adjustedDate = datefns.subDays(date, 1)
    } else {
        adjustedDate = date
    }

    return datefns.format(adjustedDate, 'yyyy-MM-dd')
}

export const filterIssueForGraphs = (issue: IssueEntity) =>
    ['Guarantor fee issue', 'Non-cash issue'].includes(issue.type) === false &&
    getDateForIssue(issue) !== null &&
    (issue.unitSubTotal !== null || issue.secondarySub !== null) &&
    !hasSourceOfType(issue, 'Cancellation') &&
    isSpecialUnitIssue(issue) === false

export const getDateForIssue = (issue: IssueEntity) => {
    switch (issue.type) {
        case 'Rights issue':
        case 'IPO':
            return issue.subEndDate
        case 'Directed issue':
        case 'ABB Directed issue':
            if (issue.publicationDate === null) return null

            return getMarketAdjustedDate(new Date(issue.publicationDate)) as string
        default:
            console.warn(`Unexpected issue type: ${issue.type}`)
            return null
    }
}
